// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Component, OnInit } from '@angular/core';
import { BaseWidget } from 'gridstack/dist/angular';
import { SelectedOrgMethod } from '../../../../shared/selectedOrg';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { HeaderService } from '../../../header.service';
import { D3eService } from '../../../../services/d3e-service';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { withLoading } from '../../../../shared/misc';

@UntilDestroy({checkProperties: true})
@Component({
    selector: 'app-endpoints-connected',
    templateUrl: './endpoints-connected.component.html',
    styleUrls: ['./endpoints-connected.component.scss'],
    standalone: false
})
export class EndpointsConnectedComponent extends BaseWidget implements OnInit {
  connected$: Observable<number> = new Observable<number>();
  loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private headerService: HeaderService,
              private d3eService: D3eService) {
    super();
  }

  ngOnInit(): void {
    this.connected$ = this.headerService.orgSelectedChanged
      .pipe(
        tap(() => this.loading$.next(true)),
        switchMap((selectedOrgId) => {
          const selectedOrg = SelectedOrgMethod.getSelectedOrg(selectedOrgId);
            return this.d3eService.getEndpointsConnected(selectedOrg).pipe(
                withLoading(isLoading => this.loading$.next(isLoading))
            );
        }),
        map(response => response.endpointsConnected),
        catchError(error => {
          this.loading$.next(false);
          // TODO: pass error to child? so it can show error appropriately?
          //  Also, show a snack bar with error?
          return throwError(error);
        }),
        untilDestroyed(this)
      );
  }

}
